import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import ClientLogoSlider from "./ClientLogoSlider";
import ESGSlider from "./ESGSlider";
import { Link } from "react-router-dom";

function AccelTrack() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const blogs = [
    {
      id: 1,
      title:
        "Listed Companies Turn to AccelTRACK for Cutting-Edge ESG Reporting and Compliance Solutions",
      subtitle: "by admin | Oct 22, 2024 | Blog",
      image: assets.blogthumb1,
      description:
        "As the demand for environmental, social, and governance (ESG) transparency rises, listed companies across industries...",
    },
    {
      id: 2,
      title:
        "Australia Passes Landmark Climate Disclosure Legislation and Establishes Net Zero Economy Authority",
      subtitle: "by admin | Sep 10, 2024 | Blog",
      image: assets.blogthumb2,
      description:
        "In a major step towards advancing climate action, Australia’s House of Representatives has passed the Treasury Laws...",
    },
    {
      id: 3,
      title:
        "Tracy’s Odyssey: Navigating ESG Regulations and Building Sustainable Supply Chains with AccelESG",
      subtitle: "by admin | Apr 18, 2024 | Blog",
      image: assets.blogthumb3,
      description:
        "A few years ago, I was asked to moderate a Next Generation Oil and Gas panel entitled The Race to Net Zero, which...",
    },
  ];

  return (
    <div>
      <div className="inner-new-section-1 acceltrack-bg-1">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 max-width-500 padding-bottom-1">
            {/* <img
              src={assets.AccelTRACKLogo}
              alt="AccelALERT"
              data-aos="fade-down"
            /> */}
            <h1 className="white-color" data-aos="zoom-in">
              AccelTRACK<sup>™</sup> – The ESG & Carbon Data Backbone for Modern
              Enterprises
            </h1>
            <p data-aos="zoom-in">
              Empowering organizations to see, understand, and act on
              sustainability data—seamlessly and at scale.
            </p>
            <div className="text-left">
              <Link
                to="/company/contact#Book-Meeting"
                className="button-1 light-green-bg"
                data-aos="fade-up"
              >
                Request a Demo
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 acceltrack-bg-2 height-inherit-1">
        <div className="wrapper ">
          {/* <ESGSlider /> */}
          <div className="acceltrack-slide">
            <a
              href="https://www2.everestgrp.com/reportaction/EGR-2024-74-R-6585/Marketing"
              target="_blank"
            >
              <h4>
                AccelTRACK™ is recognized as a Major Contender in the 2024 ESG
                Data Management Platform PEAK Matrix® Assessment by Everest
                Group
              </h4>
              <p>
                This distinction validates our platform’s powerful capabilities
                in ESG data management, regulatory alignment, and user-driven
                innovation.
              </p>
            </a>
          </div>
        </div>
      </div>

      <div className="bg-section-1 acceltrack-bg-3">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="blue-color-2" data-aos="fade-up">
              A Future-Proof ESG & Carbon Intelligence Engine
            </h2>
            <p className="blue-color-2" data-aos="fade-down">
              AccelTRACK™ is a purpose-built platform designed to unify all your
              ESG data—environmental, social, governance, and carbon—into one
              intelligent system. From global enterprises to public sector
              institutions, AccelTRACK™ is the foundation for high-quality
              sustainability reporting, regulatory compliance, and carbon
              disclosure.
            </p>
          </div>
          <div className="text-center">
            <img
              src={assets.AccelTrack1}
              alt="AccelALERt2"
              className="img-w-1"
              data-aos="fade-up"
            />
          </div>
        </div>
      </div>

      <div className="bg-section-1 acceltrack-bg-4">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="light-green-color">AccelTRACK™ Core Capabilities</h2>
          </div>
          <div className="text-center">
            <img
              src={assets.AccelTrack2}
              alt="AccelALERt2"
              className="img-w-1"
              data-aos="fade-down"
            />
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 acceltrack-bg-5">
        <div className="wrapper height-inherit">
          <h2 data-aos="fade-down">A Platform Built for Action</h2>

          <div className="section-2-2 flex-column">
            <div className="SituationalIntelligence flex-end">
              <div className="black-bg-2">
                <p data-aos="fade-up">
                  “AccelTRACK™ stands out as the backbone of ESG strategy. It
                  empowers teams to stop chasing spreadsheets and start making
                  sustainable decisions.”
                </p>
                <i data-aos="fade-up">— Mark Becking</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 acceltrack-bg-6">
        <div className="wrapper height-inherit">
          <div class="building-section-2-1">
            <h2 className="blue-color-2" data-aos="fade-up">
              Seamless Integration, No Lock-Ins
            </h2>

            <div className="building-list">
              <ul data-aos="fade-down">
                <li>
                  Integrates with 50+ ERP, IoT, energy, and <br />
                  emissions systems
                </li>
                <li>Open APIs for complete interoperability</li>
                <li>No third-party tech dependencies</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-section-1 acceltrack-bg-7">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="light-green-color" data-aos="fade-up">
              Compliance. Reporting. Confidence.
            </h2>
            <p data-aos="fade-down">
              Stay ahead of rapidly evolving ESG mandates with pre-configured
              compliance workflows for:
            </p>
          </div>
          <div className="text-center">
            <div className="acceltrack-three-col-main">
              <div className="acceltrack-three-col-1" data-aos="zoom-in">
                <b>CSRD (EU)</b>
              </div>
              <div className="acceltrack-three-col-1" data-aos="zoom-in">
                <b>UAE Federal Decree 11, UAE Sustainability Framework</b>
              </div>
              <div className="acceltrack-three-col-1" data-aos="zoom-in">
                <b>CDP, GRESB, TCFD and others</b>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-section-1 acceltrack-bg-8">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="light-green-color">Trusted by Industry Leaders</h2>
          </div>
          <ClientLogoSlider />

          <ESGSlider />
        </div>
      </div>

      <div className="bg-section-1 acceltrack-bg-9">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="light-green-color">Why Choose AccelALERT™?</h2>
          </div>
          <div className="text-center">
            <img
              src={assets.AccelTrack3}
              alt="AccelALERt2"
              className="img-w-1"
              data-aos="zoom-in"
            />
          </div>
        </div>
      </div>

      <div className="flagship-bg height-inherit-1">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="blue-color">Insights & Innovations</h2>
          </div>
          <div className="blog-sec">
            {blogs.map((blog) => (
              <div key={blog.id} className="blog-m-item">
                <Link to={`/blog/${blog.id}`} onClick={scrollToTop}>
                  <img src={blog.image} alt={blog.title} />
                  <div className="blog-content">
                    <h4>{blog.title}</h4>
                    <h5>{blog.subtitle}</h5>
                    <p>{blog.description}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          {/* <div className="flagship-heading">
            <h2 className="blue-color">Whitepapers</h2>
            <TabImage3 />
          </div> */}
        </div>
      </div>

      <div className="ClimateFutureTogether-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="light-green-color">
              Build Your ESG & Carbon Backbone Today
            </h2>
            <p>
              Join the most forward-thinking organizations building their ESG
              and climate intelligence with AccelTRACK™.
            </p>

            <Link
              to="/company/contact#Book-Meeting"
              className="button-1 light-green-bg-2"
              onClick={scrollToTop}
            >
              Schedule a Consultation
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccelTrack;
